import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { AnalyticsService } from './analytics-service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsFormService {
  constructor(private analyticsService: AnalyticsService) {}

  public sendEventForInvalidControls(controls: { [key: string]: AbstractControl }, formName: string): void {
    for (const fieldName in controls) {
      if (controls[fieldName].invalid) {
        this.track(fieldName, formName);
      }
    }
  }

  public sendEventForCaughtError(fieldName: string, formName: string): void {
    this.track(fieldName, formName);
  }

  private track(fieldName: string, formName: string): void {
    this.analyticsService.trackGtmFormEvent(fieldName, formName, 'Error form field');
  }
}
